import type { Paths } from '@/notificationForms'
import { useEffect } from 'react'

/**
 * Reset the editing state each time `path` changes
 */
export function useResetEditingStateOnUnmount(resetEditing: () => void, path: Paths) {
  useEffect(() => () => resetEditing(), [resetEditing, path])
}
